var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._v("提示：该应用只支持手机端！")])
}
var staticRenderFns = []

export { render, staticRenderFns }